export function getKeys<TObject extends Record<string, unknown>>(object: TObject): Array<keyof TObject & string> {
    return Object.keys(object);
}
